/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Попап с выбором авто для фильтрации страницы "Шины и Диски".
   */
  app.CarPopupFilterView = app.BaseFilterView.extend({
    el: '.popup-car-setter-filter',
    additionalOptions: ['fader'],
    events: {
      'click .js-show-all': 'showAll',
      'click .js-hide-all': 'hideAll',
      'keyup .js-input-filter-txt': 'handleSearch',
      'click .js-filter-value': 'setFilter',
      'click .js-breadcrumbs': 'setStage',
    },
    stages: ['car_vendor', 'car_model', 'car_year', 'car_modification'],
    filterData: {},
    MAX_VALUES_SHOWN: 20,
    /**
     * @inheritDoc
     */
    run: function () {
      this.initPopup();
      this.template = app.helpers.TemplateHelper.getTemplate('#car-popup-filter-template');
    },
    /**
     * Устанавливает значения, переданные из родительской TiresAndWheelsFilterView.
     * @param {Object} data  Марки автомобиля и тип
     */
    setData: function (data) {
      // переводим в массив данные пришедших фильтров.
      for (var filter in data.sub_filters) {
        if (data.sub_filters.hasOwnProperty(filter)) {
          data.sub_filters[filter].values = _.toArray(data.sub_filters[filter].values);
        }
      }
      this.filterData = data;
      if (data.selectedQty) {
        this.currentStage = _.last(this.stages);
      } else {
        this.currentStage = _.first(this.stages);
      }
      this.render(data);
    },
    /**
     * @inheritDoc
     */
    render: function (data) {
      var values = _.toArray(_.get(data, ['sub_filters', this.currentStage, 'values']));
      // форматируем пройденные этапы для формирования хлебных крошек.
      var selectedStages = _.take(this.stages, this.stages.indexOf(this.currentStage) + 1)
        .map(function (stage) {
          var filterValues = _.get(data, ['sub_filters', stage, 'values']);
          return {
            name: stage,
            selectedFilter: _.find(filterValues, 'selected'),
          };
        });
      this.$('.container').html(this.template({
        values: values,
        currentStage: this.currentStage,
        stages: selectedStages,
        placeholder: _.get(data, ['sub_filters', this.currentStage, 'name']),
        max: this.MAX_VALUES_SHOWN,
        carModelId: _.get(_.find(selectedStages, {name: 'car_model'}), ['selectedFilter', 'id']),
        each: _.each,
      }));

      return this;
    },
    /**
     * Инициализация попапа.
     */
    initPopup: function () {
      this.popup = new als.Popup(this.$el);
      this.popup.addEventListener(als.Popup.EventType.BEFORE_OPEN, this.handlePopupOpen.bind(this));
      this.popup.addEventListener(als.Popup.EventType.BEFORE_CLOSE, this.handlePopupClose.bind(this));
    },
    /**
     * Выполняется перед открытием попапа.
     */
    handlePopupOpen: function () {
      this.fader.show();
      app.helpers.PopupPositioningHelper.positionCenterOfWindow(this.$el);
    },
    /**
     * Выполняется перед закрытием попапа.
     */
    handlePopupClose: function () {
      this.fader.hide();
    },
    /**
     * Открытие попапа.
     */
    openPopup: function () {
      // костыль для лебедевского попапа
      setTimeout(function () {
        this.popup.open();
      }.bind(this), 0);
    },
    /**
     * Закрытие попапа.
     */
    close: function () {
      this.popup.close();
    },

    /**
     * Открытие/закрытие попапа.
     */
    togglePopup: function () {
      if (this.popup.closed_) {
        this.openPopup();
      } else {
        this.close();
      }
    },
    /**
     * Показать весь список.
     */
    showAll: function () {
      this.$('.item-car').removeClass('not_display');
      this.$('.container-brands').removeClass('wrapped');
      this.$('.link-show-all').addClass('js-hide-all').removeClass('js-show-all').find('.link').text('Скрыть');
    },
    /**
     * Скрыть весь список.
     */
    hideAll: function () {
      var maxShown = this.MAX_VALUES_SHOWN - 1;
      _.each(this.$('.item-car'), function (item, index) {
        if (index >= maxShown) {
          $(item).addClass('not_display');
        }
      });

      this.$('.container-brands').scrollTop(0).addClass('wrapped');
      this.$('.link-show-all').removeClass('js-hide-all').addClass('js-show-all').find('.link').text('Показать все');
    },
    /**
     * Обрабатываем набор символов в поисковой строке.
     * @param {Event} e
     */
    handleSearch: function (e) {
      e.stopPropagation();
      e.preventDefault();
      var query = String($(e.currentTarget).val()).toLowerCase();
      if (e.keyCode === app.KEY_CODES.Escape) {
        if (!query) {
          this.close();
        }
        query = '';
        this.$('.js-input-filter-txt').val('');
      }
      this.filterList(query);
    },
    /**
     * Отфильтровать список выводимых марок и моделей авто.
     * @param {String} [query] запрос в поисковой строке
     */
    filterList: function (query) {
      var $items = this.$('.item-car'),
        action = query ? 'removeClass' : 'addClass';
      _.each($items, function (item) {
        var filterName = String($(item).text().trim()).toLowerCase();
        if (_.includes(filterName, query)) {
          $(item).removeClass('not_display');
          if (query) {
            $(item).unhighlight();
            $(item).highlight(query);
          } else {
            $(item).unhighlight();
          }
        } else {
          $(item).addClass('not_display');
        }
      });
      if (query) {
        this.$('.link-show-all').addClass('not_display');
      } else {
        this.$('.link-show-all').removeClass('not_display');
        if (this.$('.container-brands').hasClass('wrapped')) {
          this.hideAll();
        }
      }
      this.$('.reset-search')[action]('not_display');
    },
    /**
     * Сбрасываем поисковую строку в дефолтное состояние.
     * @param {Event} e
     */
    resetSearch: function (e) {
      e.stopPropagation();
      e.preventDefault();
      this.$('.js-input-filter-txt').val('');
      this.filterList('');
    },
    /**
     * Устанавливает параметры автомобиля.
     * @param {Event} e
     */
    setFilter: function (e) {
      var $item = this.$(e.currentTarget),
        id = $item.data('id'),
        carModelId = $item.data('carModelId'),
        params,
        endpoint;

      switch (this.currentStage) {
        case 'car_vendor':
          endpoint = 'car-model';
          params = {
            car_vendor_id: id,
          };
          break;
        case 'car_model':
          endpoint = 'car-modification';
          params = {
            car_model_id: id,
            only_years: 1,
          };
          break;
        case 'car_year':
          endpoint = 'car-modification';
          params = {
            car_model_id: carModelId,
            year: id,
          };
          break;
        case 'car_modification':
          var filterObj = {
            car_modification: id,
          };
          this.currentStage = _.first(this.stages);
          this.trigger('apply-car-filter', filterObj);
          this.close();
          return;
      }

      this.fetchData(endpoint, params, id);
    },
    /**
     * Запрашиваем данные для фильтра по модификации.
     * @param {string} endpoint путь для запроса
     * @param {Object} params параметры запроса
     * @param {number} id идентификатор выбранного фильтра
     */
    fetchData: function (endpoint, params, id) {
      var url = app.entryScriptName + '/api/v3/' + endpoint + '/';
      var that = this;
      $.ajax(url, {
        data: params,
      }).done(function (data) {
        // В объект с данными фильтра пишем выбранный фильтр
        if (_.has(that.filterData, ['sub_filters', that.currentStage, 'values'])) {
          _.each(that.filterData.sub_filters[that.currentStage].values, function (item) {
            item.selected = item.id === id;
          });
        }
        that.filterData.selectedQty++;
        // Переходим в следующее состояние.
        that.currentStage = that.stages[that.stages.indexOf(that.currentStage) + 1];

        // приводим данные по годам к общему виду
        if (that.currentStage === 'car_year') {
          data.items = _.toArray(data.items).map(function (item) {
            return {id: item.year, name: item.year};
          });
        }
        _.set(that.filterData, ['sub_filters', that.currentStage, 'values'], _.toArray(data.items));
        that.render(that.filterData);
      });
    },
    /**
     * При переходе по хлебным крошкам в попапе.
     * @param {Event} e
     */
    setStage: function (e) {
      var target = this.$(e.currentTarget),
        stage = target.data('stage'),
        that = this,
        stagesToClear = _.slice(this.stages, this.stages.indexOf(stage) + 1, this.stages.length);
      _.each(stagesToClear, function (stage) {
        _.set(that.filterData, ['sub_filters', stage, 'values'], []);
      });
      this.currentStage = stage;
      this.render(this.filterData);
    },
  });
})(jQuery);

}.call(window));